import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { findSiteId, findStudySiteIdentities } from '../../shared/route-helpers';
import { SponsorStudySiteIdentity } from '../sites/sponsor-study-site-identity';

@Injectable()
export class SponsorSelectedStudySiteIdentityResolver implements Resolve<SponsorStudySiteIdentity> {
    constructor() { }

    public resolve(route: ActivatedRouteSnapshot): SponsorStudySiteIdentity {
        const siteIdentities = findStudySiteIdentities(route);
        const siteId = findSiteId(route);

        const selectedSiteIdentity = siteIdentities.find(t => t.siteId === siteId);
        return selectedSiteIdentity;
    }
}